export const ROLES = {
  CONSULTANT: 'consultant',
  LEARNER: 'learner'
}


export const PERMISSIONS = {
  COURSES: 'courses'
}
